import { ArrowBackIcon, ChevronRightIcon } from '@toasttab/buffet-pui-icons'
import React, { useState } from 'react'
import { TrackingDetails } from 'src/apollo/onlineOrdering'
import {
  Modal,
  ModalContent,
  ModalOverlay
} from 'src/shared/components/common/modal'
import { t } from 'src/translations/src'

export const DeliveryPhotoSection = ({
  trackingDetails
}: {
  trackingDetails?: TrackingDetails | null
}) => {
  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false)
  const driverName = trackingDetails?.deliveryDriver?.name
  const dropOffImageUrl = trackingDetails?.dropOffImageUrl

  if (!driverName || !dropOffImageUrl) return null

  return (
    <>
      <div
        className='orderConfirmationSection smallPadding'
        data-testid='delivery-photo-section'
      >
        <button
          className='deliveryPhotoButton'
          onClick={() => setIsPhotoModalOpen(true)}
          data-testid='delivery-photo-button'
        >
          <img
            src={dropOffImageUrl}
            alt={t(
              'order-confirmation.delivery-photo.modal.photo-of-the-delivery'
            )}
            className='deliveryPhoto'
          />
          <div className='textContainer'>
            <h3>
              {t('order-confirmation.delivery-photo.modal.header', {
                driverName
              })}
            </h3>
          </div>
          <ChevronRightIcon accessibility='decorative' />
        </button>
      </div>
      <Modal
        isOpen={isPhotoModalOpen}
        onClose={() => setIsPhotoModalOpen(false)}
        testId='delivery-photo-modal'
      >
        <ModalOverlay />
        <ModalContent contentClassName='deliveryPhotoModal modalContentV2 fullScreenMobile'>
          <div className='modalHeader'>
            <button
              onClick={() => setIsPhotoModalOpen(false)}
              data-testid='modal-back-button'
            >
              <ArrowBackIcon
                accessibility='semantic'
                aria-label={t(
                  'order-confirmation.delivery-photo.modal.back-button'
                )}
              />
            </button>
            <h2>
              {t('order-confirmation.delivery-photo.modal.header', {
                driverName
              })}
            </h2>
          </div>
          <div className='deliveryPhotoContainer'>
            <img
              src={dropOffImageUrl}
              alt={t(
                'order-confirmation.delivery-photo.modal.photo-of-the-delivery'
              )}
              className='deliveryPhoto'
            />
          </div>
        </ModalContent>
      </Modal>
    </>
  )
}
